<template>
    <div class="car-image">
        <div v-if="imageSrc">
            <div>
                <img class="tw-w-full" :src="imageSrc" :alt="activeColor && activeColor.description" height="auto">
            </div>
            <div class="tw-flex tw-justify-center tw-mt-1">
                <span class="tw-text-slate-200 tw-text-xs">
                    {{ $t('configuration-wizard.image-disclaimer') }}
                </span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'CarImage',
    props: {
        /**
         * Selected color object
         */
        activeColor: {
            type: Object,
            default: () => ({}),
        },
        /**
         * Default image of the vehicle
         */
        defaultImage: {
            type: String,
            default: '',
        },
    },
    computed: {
        imageSrc() {
            return (
                (this.activeColor && this.activeColor.colorImage && this.activeColor.colorImage.image800) ||
                this.defaultImage ||
                ''
            );
        },
    },
};
</script>
